
export default function downloadFile({url,name}) {
    const link = document.createElement('a');
    const blobURL = url;

    link.style.display = 'none';
    link.href = blobURL;
    link.setAttribute('download',name);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}